import React from 'react';
import background from '../../assets/arabica.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoArabica extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Arabica Trees"
        paragraph="Warming sea surface temperatures are forcing populations of the American lobster (Homarus americanus) to higher latitudes than ever before—and upending fishing communities on the New England coast."
        background={background}
     />
  
  );
 }
}   

export default InfoArabica;